const configuredApiHost = (process.env.VUE_APP_API_URL || '')
  .replace(/^https?:\/\//, '')
  .split('/')[0];

const IOS_COOKIE_DOMAINS = configuredApiHost === ''
  ? ['api.xviii.golf/']
  : [`${configuredApiHost}/`, 'api.xviii.golf/'];

function isIOSCordova() {
  return (
    process.env.VUE_APP_ENV === 'cordova'
    && process.env.VUE_APP_CORDOVA_PLATFORM === 'ios'
  );
}

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function waitForDeviceReady(timeoutMs = 1200) {
  if (!isIOSCordova() || typeof document === 'undefined') {
    return Promise.resolve(false);
  }

  if (window.cordova !== undefined) {
    return Promise.resolve(true);
  }

  return new Promise((resolve) => {
    let settled = false;
    let onReady = () => {};

    const finish = (result) => {
      if (settled) {
        return;
      }

      settled = true;
      document.removeEventListener('deviceready', onReady, false);
      resolve(result);
    };

    onReady = () => finish(true);
    document.addEventListener('deviceready', onReady, false);
    setTimeout(() => finish(window.cordova !== undefined), timeoutMs);
  });
}

function injectCookieDomain(domain) {
  return new Promise((resolve) => {
    try {
      if (
        window.wkWebView === undefined
        || typeof window.wkWebView.injectCookie !== 'function'
      ) {
        resolve(false);
        return;
      }

      window.wkWebView.injectCookie(
        domain,
        () => resolve(true),
        () => resolve(false),
      );
    } catch (err) {
      resolve(false);
    }
  });
}

async function runIOSCookieWarmup(options = {}) {
  const attempts = options.attempts === undefined ? 3 : options.attempts;
  const delayMs = options.delayMs === undefined ? 250 : options.delayMs;

  if (!isIOSCordova()) {
    return { performed: false, success: false };
  }

  await waitForDeviceReady(options.deviceReadyTimeoutMs || 1200);

  const runAttempt = async (attempt) => {
    const results = await Promise.all(IOS_COOKIE_DOMAINS.map(injectCookieDomain));
    const anySuccess = results.some(result => result === true);
    if (anySuccess) {
      return true;
    }

    if (attempt >= attempts - 1) {
      return false;
    }

    await wait(delayMs * (attempt + 1));
    return runAttempt(attempt + 1);
  };

  const anySuccess = await runAttempt(0);
  return { performed: true, success: anySuccess };
}

export {
  isIOSCordova,
  runIOSCookieWarmup,
};
